import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Chip } from "@/components/common";
import { SliderField } from "@/components/SliderField";
import { Field } from "@/components/profile/ProfileSections";

export const ZONE_LABELS = { rodilla: "Rodilla", espalda: "Espalda", hombro: "Hombro", cuello: "Cuello", tobillo: "Tobillo", cadera: "Cadera", muñeca: "Muñeca / codo", otra: "Otra" };
export const emptyAilment = () => ({ zone: "rodilla", name: "", intensity: 4, since: new Date().toISOString().slice(0, 10), notes: "", active: true });

export const AilmentForm = ({ a, set }) => (
  <div className="space-y-5">
    <Field label="Zona">
      <div className="flex flex-wrap gap-2">
        {Object.entries(ZONE_LABELS).map(([z, l]) => <Chip key={z} tone="care" active={a.zone === z} onClick={() => set({ zone: z })} testid={`ailment-zone-${z}`}>{l}</Chip>)}
      </div>
    </Field>
    <Field label="¿Qué te pasa?">
      <Input placeholder="Ej.: dolor lumbar al estar sentado" value={a.name} onChange={(e) => set({ name: e.target.value })} className="h-12 rounded-2xl" data-testid="ailment-name-input" />
    </Field>
    <SliderField label="Intensidad del dolor" value={a.intensity} min={0} max={10} onChange={(v) => set({ intensity: v })} testid="ailment-intensity" hint="0 = sin dolor · 10 = insoportable" />
    <Field label="¿Desde cuándo?">
      <Input type="date" value={a.since} onChange={(e) => set({ since: e.target.value })} className="h-12 rounded-2xl" data-testid="ailment-since-input" />
    </Field>
    <Field label="Notas (opcional)">
      <Textarea placeholder="Qué lo empeora, qué lo alivia…" value={a.notes} onChange={(e) => set({ notes: e.target.value })} className="rounded-2xl" data-testid="ailment-notes-input" />
    </Field>
  </div>
);
